import { Contact } from './contact.model';
import { Entreprise } from './entreprise.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class MonCompte {
    static jsonMap = {
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        email: { key: 'email', optional: true, default: '' },
        emailEntreprise: { key: 'emailEntreprise', optional: true, default: '' },
        fax: { key: 'fax', optional: true, default: '' },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        structureJuridique: { key: 'structureJuridique', optional: true, default: '' },
        telephoneFixe: { key: 'telephoneFixe', optional: true, default: '' },
        telephoneMobile: { key: 'telephoneMobile', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        notificationDocumentaire: { key: 'notificationDocumentaire', optional: true },
        contacts: { key: 'contacts', converter: new (ArrayClassConverterFactory.build(Contact))(), default: () => [] },
        groupementProducteurs: { key: 'groupementProducteurs', converter: new (ClassConverterFactory.build(Entreprise))(), optional: true }
    };

    adresse: string;
    codePostal: string;
    email: string;
    emailEntreprise: string;
    fax: string;
    nom: string;
    prenom: string;
    raisonSociale: string;
    siret: string;
    structureJuridique: string;
    telephoneFixe: string;
    telephoneMobile: string;
    ville: string;
    notificationDocumentaire: boolean;
    contacts: Contact[];
    groupementProducteurs: Entreprise;
}
